export default $(document).ready(e => {
    const start_date = $('#id_created_0');
    const end_date = $('#id_created_1');

    start_date.datepicker({
        format: 'dd.mm.yyyy',
        autoclose: true,
        language: 'de',
        todayHighlight: true,
    });

    end_date.datepicker({
        format: 'dd.mm.yyyy',
        autoclose: true,
        language: 'de',
        todayHighlight: true,
    });

})
